export default __webpack_public_path__ + "static/media/staffoutsourcing.71850511.svg";